import { default as content } from '../AddNewPayeeLandingPage/index.content';
import withValidation from '../../../containers/withValidation';
import { Select, Input, GenericTextArea } from '../../../sharedComponents/Form';
import withBackEndError from '../../../containers/withBackEndError';

const {
	nameErrorMessage,
	displayNameErrorMessage,
	payeeAddressLine1ErrorMessage,
	bankAddressLine1ErrorMessage,
	payeeCityErrorMessage,
	bankCityErrorMessage,
	payeeCountryErrorMessage,
	bankCountryErrorMessage,
	bankNameErrorMessage,
	IBANErrorMessage,
	internationalAccountNumberErrorMessage,
	BICOrSWIFTErrorMessage,
	clearingCodeRequiredMessage,
	swiftReferenceInvalidCharsErrorMessage,
} = content;

export const NameInput = withValidation({
	validations: ['required', 'swift'],
	key: 'internationalPayeeName',
	message: nameErrorMessage,
})(Input);
export const DisplayNameInput = withValidation({
	validations: ['required'],
	key: 'displayName',
	message: displayNameErrorMessage,
})(Input);
export const PayeeAddressLine1 = withValidation({
	validations: ['required', 'swift'],
	key: 'payeeAddressLine1',
	message: payeeAddressLine1ErrorMessage,
})(Input);
export const PayeeCity = withValidation({
	validations: ['required', 'swift'],
	key: 'payeeCity',
	message: payeeCityErrorMessage,
})(Input);
export const PayeeCountry = withValidation({
	validations: ['required'],
	key: 'payeeCountry',
	message: payeeCountryErrorMessage,
})(Select);
export const BankName = withValidation({
	validations: ['required', 'swift'],
	key: 'bankName',
	message: bankNameErrorMessage,
})(Input);
export const BankAddressLine1 = withValidation({
	validations: ['required', 'swift'],
	key: 'bankAddressLine1',
	message: bankAddressLine1ErrorMessage,
})(Input);
export const BankCity = withValidation({
	validations: ['required', 'swift'],
	key: 'bankCity',
	message: bankCityErrorMessage,
})(Input);
export const BankCountry = withValidation({
	validations: ['required'],
	key: 'bankCountry',
	message: bankCountryErrorMessage,
})(Select);
export const IBAN = withValidation({
	validations: ['required', 'alphaNumeric'],
	key: 'iban',
	message: IBANErrorMessage,
})(withBackEndError(Input));
export const InternationalAccountNumber = withValidation({
	validations: ['required', 'alphaNumeric'],
	key: 'internationalAccountNumber',
	message: internationalAccountNumberErrorMessage,
})(withBackEndError(Input));
export const BICOrSWIFT = withValidation({
	validations: ['required', 'alphaNumeric', 'bicLength'],
	key: 'bickOrSwift',
	message: BICOrSWIFTErrorMessage,
})(withBackEndError(Input));
export const ClearingCode = withValidation({
	validations: ['required'],
	key: 'clearingCode',
	message: clearingCodeRequiredMessage,
})(withBackEndError(Input));
export const PaymentReasonTextArea = withValidation({
	validations: ['swiftMultiChar'],
	key: 'paymentReason',
	message: swiftReferenceInvalidCharsErrorMessage,
})(withBackEndError(GenericTextArea));
